import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const UserRow = ({ user }) => {
  return (
    <tr>
      <td>
        <Link to={'/users/' + user.id}>{user.id}</Link>
      </td>
      <td>{user.lastName + ', ' + user.firstName}</td>
      <td>{user.email}</td>
      <td>{user.username}</td>
      <td>{user.initials}</td>
      <td>{user.payRate ? '$' + user.payRate.toFixed(2) : 'N/A'}</td>
    </tr>
  );
};

UserRow.propTypes = {
  user: PropTypes.object.isRequired,
};

export default UserRow;



// WEBPACK FOOTER //
// ./src/components/user/UserRow.js